module.exports = __webpack_public_path__ + "static/media/pexels-photo-2.6ea9d777.png";